var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginScreen',{staticClass:"bg-light",attrs:{"loading":_vm.loading || _vm.$store.getters.getLoading,"errors":_vm.$store.state.auth.loginErrors},on:{"login":_vm.login,"lostPassword":_vm.lostPassword,"setLanguage":_vm.setLanguage}})}
var staticRenderFns = []

export { render, staticRenderFns }